import styled from 'styled-components';

import { FONT_WEIGHT_SEMIBOLD, NEUTRAL_800 } from 'styles/tokens';

import Text from './Text';

const PrimaryText = styled(Text)`
  color: ${NEUTRAL_800};
  font-weight: ${FONT_WEIGHT_SEMIBOLD};
`;

export default PrimaryText;
